import PostLoginLayout from "@/components/layouts/PostLoginLayout/PostLoginLayout";
import AppShell from "@/custolink-newdesign/shell/AppShell";
import { isNewDesign } from "@/custolink-newdesign/flag";

import { useWebsocketsForAdminArea } from "@/custolink-hooks/user_notifications/UseWebsocketsForAdminArea";
import { useEffect } from "react";
import { AdmUserNotificationsApi } from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";
import { useQuery } from "@tanstack/react-query";
import { adminAreaNotifications } from "@/custolink-state/ui_admin_area_notifications";
import { useAtom } from "jotai";

export default function AdminArea(p: { children: React.ReactNode }) {
  useWebsocketsForAdminArea();

  const [, setAdminAreaNotifications] = useAtom(adminAreaNotifications);

  const getLatest10Notifications = useQuery({
    queryFn: () =>
      AdmUserNotificationsApi.getLatest10NotificationsForOrganisationAdminArea(),
    refetchInterval: 30000,
    queryKey: [
      "AdmUserNotificationsApi",
      AdmUserNotificationsApi.getLatest10NotificationsForOrganisationAdminArea
        .name,
    ],
  });

  useEffect(() => {
    if (getLatest10Notifications.data != null) {
      setAdminAreaNotifications((s) => {
        return { ...s, latest10: getLatest10Notifications.data.list };
      });
    }
  }, [getLatest10Notifications.data]);

  // The new design swaps the shell only. Notifications, websockets and every
  // hook above stay exactly as they are - this is a presentation switch.
  if (isNewDesign()) {
    return <AppShell>{p.children}</AppShell>;
  }

  return (
    <>
      <PostLoginLayout layoutType={"collapsibleSide"}>
        {p.children}
      </PostLoginLayout>
    </>
  );
}
